import { AfterContentChecked, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ControlsModule } from 'segov-sigepo-lib';
import { SegovSigepoPesquisaFormComponent } from 'src/app/controls/segov-sigepo-pesquisa-form/segov-sigepo-pesquisa-form.component';
import { SegovSigepoPortalBodyComponent } from 'src/app/controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';
import { CardDadosPublicacaoComponent } from './sub-views/card-dados-publicacao/card-dados-publicacao.component';
import { PesquisarJornalPaginadoState } from 'src/app/stateManagement/reducers/Pesquisa/pesquisar-jornal-paginado.reducer';
import { Store } from '@ngrx/store';
import { filter, Subscription } from 'rxjs';
import { pesquisarJornalPaginado, pesquisarJornalPaginadoFinish } from 'src/app/stateManagement/actions/Pesquisa/pesquisar-jornal-paginado.action';
import { PesquisaBasicaJornalInputDto } from 'src/app/domain/DTOs/input/pesquisa-basica-jornal.input.dto';
import { selectDadosPesquisarJornalPaginado, selectErrosPesquisarJornalPaginado } from 'src/app/stateManagement/selectors/Pesquisa/pesquisar-jornal-paginado.selector';
import { ResultadoPesquisaJornalOutputDto } from 'src/app/domain/DTOs/output/jornal/resultado-pesquisa-jornal.output.dto';
import { CommonModule } from '@angular/common';
import { ToastState } from 'src/app/stateManagement/reducers/toast.reducer';
import { toastShow } from 'src/app/stateManagement/actions/toast.action';
import { ToastModel, ToastType } from 'src/app/domain/models/toast.model';
import { CommonMessages } from 'src/app/utils/common.messages';
import { ObterEdicaoPorIdState } from 'src/app/stateManagement/reducers/Jornal/obter-edicao-por-id.reducer';
import { saveAs } from 'file-saver-es';
import { obterEdicaoPorId, obterEdicaoPorIdFinish } from 'src/app/stateManagement/actions/Jornal/obter-edicao-por-id.action';
import { selectDadosObterEdicaoPorId } from 'src/app/stateManagement/selectors/Jornal/obter-edicao-por-id.selector';
import { CommonConverter } from 'src/app/utils/common.converter';
import { PdfManager } from 'segov-sigepo-ui-component/projects/segov-sigepo-component/src/lib/utils/pdf-manager.service';
import { ETipoVisualizacaoMateria } from 'src/app/domain/enums/tipo-visualizacao-materia.enum';
import { baixarPdfMateriaPublicada, baixarPdfMateriaPublicadaFinish } from 'src/app/stateManagement/full-states/publicacao/baixar-pdf-materia-publicada.state';

@Component({
  selector: 'app-pesquisa-jornal-page',
  standalone: true,
  imports: [
    SegovSigepoPesquisaFormComponent,
    SegovSigepoPortalBodyComponent,

    CardDadosPublicacaoComponent,

    ControlsModule,
    CommonModule
  ],
  templateUrl: './pesquisa-jornal-page.component.html',
  styleUrl: './pesquisa-jornal-page.component.css'
})
export class PesquisaJornalPageComponent implements OnInit, OnDestroy, AfterContentChecked {
  public currentPage = 1;
  public totalPages = 0;
  public totalRegistros = 0;
  public textoPesquisa = ''

  public dataInicial?: Date;
  public dataFinal?: Date;

  public pesquisaEfetuada = false;
  public dadosPesquisa?: ResultadoPesquisaJornalOutputDto[] | null;

  private subPesquisarJornalPaginado: Subscription
  private subPesquisarJornalPaginadoError: Subscription;
  private subObterEdicaoPorId: Subscription;

  private dadosFiltroPesquisa?: PesquisaBasicaJornalInputDto
  private nomeArquivo?: string;
  private numeroPagina = 0;

  constructor(
    private cdref: ChangeDetectorRef,
    private readonly storePesquisarJornalPaginado: Store<{ pesquisarJornalPaginado: PesquisarJornalPaginadoState }>,
    private readonly storeObterEdicaoPorId: Store<{ obterEdicaoPorIdState: ObterEdicaoPorIdState }>,
    private storeToast: Store<{ toastState: ToastState }>,
  ) {
    this.subPesquisarJornalPaginado = new Subscription();
    this.subPesquisarJornalPaginadoError = new Subscription();
    this.subObterEdicaoPorId = new Subscription();
  }

  ngOnInit(): void {
    this.subPesquisarJornalPaginado = this.storePesquisarJornalPaginado.select(selectDadosPesquisarJornalPaginado)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        this.currentPage = response?.paginaAtual??1;
        this.totalPages = response?.totalDePaginas??1;
        this.totalRegistros = response?.totalDeRegistros??0;
        this.dadosPesquisa = response?.dados;
        this.pesquisaEfetuada = true;
      });

    this.subPesquisarJornalPaginadoError = this.storePesquisarJornalPaginado.select(selectErrosPesquisarJornalPaginado)
      .pipe(filter(state => state !== null))
      .subscribe(error => {
        error?.forEach(e => {
          this.storeToast.dispatch(toastShow({ toastModel: new ToastModel(CommonMessages.Alert, e, ToastType.Warning) }));
        })
      })

      this.subObterEdicaoPorId = this.storeObterEdicaoPorId.select(selectDadosObterEdicaoPorId)
      .subscribe(response => {
        this.baixarArquivo(response?.dados?.arquivoCadernoPrincipal?.arquivo);
      });
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ngOnDestroy(): void {
    this.subPesquisarJornalPaginado.unsubscribe();
    this.subPesquisarJornalPaginadoError.unsubscribe();
    this.storePesquisarJornalPaginado.dispatch(pesquisarJornalPaginadoFinish());

    this.subObterEdicaoPorId.unsubscribe();
    this.storeObterEdicaoPorId.dispatch(obterEdicaoPorIdFinish());
    this.storePesquisarJornalPaginado.dispatch(baixarPdfMateriaPublicadaFinish());
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    if(this.dadosFiltroPesquisa) {
      const mudarPagina = { ... this.dadosFiltroPesquisa, PaginaAtual: newPage } as PesquisaBasicaJornalInputDto
      this.efetuarPesquisa(mudarPagina);
    }
  }

  efetuarPesquisa($event: PesquisaBasicaJornalInputDto) {
    this.resetResultado();
    this.dadosFiltroPesquisa = $event;
    this.dataInicial = $event.dataPublicacaoInicial;
    this.dataFinal = $event.dataPublicacaoFinal;
    this.textoPesquisa = $event.textoPesquisa;
    this.storePesquisarJornalPaginado.dispatch(pesquisarJornalPaginado({inputDto: $event}));
  }

  public downloadPublicacao(dadosJornal: ResultadoPesquisaJornalOutputDto) {
    if (!dadosJornal)
      return;

    if (dadosJornal.tipoVisualizacaoMateria === ETipoVisualizacaoMateria.HTML) {
      if (dadosJornal.publicacaoId) {
        this.storePesquisarJornalPaginado.dispatch(
          baixarPdfMateriaPublicada({ publicacaoId: dadosJornal.publicacaoId })
        );
      } else {
        this.storeToast.dispatch(toastShow({
          toastModel: new ToastModel(
            CommonMessages.Alert,
            CommonMessages.EdicaoHtml.BaixarMateriaPublicadaErro,
            ToastType.Warning
          )
        }));
      }
      return;
    }

    this.nomeArquivo = dadosJornal.tipoCaderno
      + CommonConverter.formatDateToString(new Date(dadosJornal.dataPublicacao))
      + `_pag_${dadosJornal.pagina}`;
    this.numeroPagina = dadosJornal.pagina;
    this.getEdicaoPorId(dadosJornal.idJornal);
  }

  private getEdicaoPorId(id: number) {
    this.storeObterEdicaoPorId.dispatch(obterEdicaoPorId({ inputDto: id }))
  }

  private baixarArquivo(base64?: string){
    if(base64) {
      let blobDownload: Blob;
      PdfManager.extractPage("data:application/pdf;base64," + base64, this.numeroPagina).then(blob => {
        blobDownload = blob;
      }).then(() => {
        saveAs(blobDownload, `${this.nomeArquivo}.pdf`);
      });
    }
  }

  private resetResultado() {
    this.currentPage = 1;
    this.totalPages = 1;
    this.totalRegistros = 0;
    this.dadosPesquisa = [];
  }
}
